import { reduxForm } from 'redux-form';

import ChecklistTitleForm from './ChecklistTitleForm';

export default reduxForm({
  form: 'checklistCustomTaskTitle',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(ChecklistTitleForm);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/ChecklistTitleForm/index.js